export default __webpack_public_path__ + "static/media/unloaded-image.67471676.jpg";